// extracted by mini-css-extract-plugin
module.exports = {"agendaDropzone":"styles_agendaDropzone__3XQU0","agendaFile":"styles_agendaFile__O8bNB","agendaFileInfo":"styles_agendaFileInfo__10j7s"};